export type FormatCommand =
  | "bold"
  | "italic"
  | "insertUnorderedList"
  | "insertOrderedList";

export interface ActiveFormats {
  isBold: boolean;
  isItalic: boolean;
  isBulleted: boolean;
  isNumbered: boolean;
}

export const noActiveFormats: ActiveFormats = {
  isBold: false,
  isItalic: false,
  isBulleted: false,
  isNumbered: false,
};

export interface EditorHandle {
  getMarkdown: () => string;
  clear: () => void;
  execFormat: (command: FormatCommand) => void;
}
